export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7566.bd72c436.jpg";